define("appkit/router", 
  ["exports"],
  function(__exports__) {
    "use strict";
    var Router = Ember.Router.extend(); // ensure we don't share routes between all Router instances

    Router.map(function() {
      this.route('group-by');
      this.route('component-blocks');
      this.route('deck');
    });

    __exports__["default"] = Router;
  });